$(document).foundation();

$(document).ready(function () {

		
	// var visited = $.cookie('visited');
	//
	//   if (visited !== 'yes') {
	//
        // set cookie
  //       $.cookie('visited', 'yes', { expires: 1 });
	
	// $(".global-pop").fancybox({
  //           maxHeight: 1000,
  //           width: '80%',
  //           maxWidth: 800,
  //           fitToView: false,
  //           autoSize: false,
  //           scrolling: 'no',
  //           height: 'auto',
  //           helpers: { overlay: { closeClick: false } },
  //           padding: 0
  //            }).trigger('click');
             
     // end fancybox code 
	//
  //   }



    // utils
    initVerticalCenter();
    initAnimateInView();
    inlineSVGs([
        '.footer__social img',
        '.room__gallery img'
    ]);

    // global
    initSliders();
	initHeadings();
	initForms();
	initOffCanvas();
	initBooking();
	initPopup();

    // template specific
	initAccordions();
	initForms();
	initMaps();
	initBlog();
	initGallery();
	checkCarouselSlides();


});




function initVerticalCenter() {
    $('.vertical-center').each(function () {
        $(this).wrapInner('<div class="vertical-center-table"><div class="vertical-center-row"><div class="vertical-center-cell"></div></div></div>');
    });
}



// https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
function inlineSVGs(inputValue) {
    var selectorString = '';
    if (typeof inputValue === "object") {
        selectorString = inputValue.join(',');
    } else {
        selectorString = inputValue;
    }

    $(selectorString).each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        if (imgURL.indexOf('.svg') > -1) {
	        $.get(imgURL, function (data) {
	            // Get the SVG tag, ignore the rest
	            var $svg = $(data).find('svg');

	            // Add replaced image's ID to the new SVG
	            if (typeof imgID !== 'undefined') {
	                $svg = $svg.attr('id', imgID);
	            }
	            // Add replaced image's classes to the new SVG
	            if (typeof imgClass !== 'undefined') {
	                $svg = $svg.attr('class', imgClass + ' replaced-svg');
	            }

	            // Remove any invalid XML tags as per http://validator.w3.org
	            $svg = $svg.removeAttr('xmlns:a');

	            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
	            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
	                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
	            }

	            // Replace image with new SVG
	            $img.replaceWith($svg);
	        }, 'xml');
        }
    });
}



function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}







/**
 * Scales any element to simulate the CSS background-size: cover property.
 * @param {DOMelement} element The element to scale
 * @param {bool} [scaleToParent] Scale the element to fill the parent instead
 *                               of the whole browser window.
 */
function coverViewport(element, scaleToParent) {
    if (typeof scaleToParent === 'undefined') { scaleToParent = false; }

    var viewportWidth, viewportHeight;
    if (scaleToParent) {
        viewportWidth = $(element).parent().innerWidth();
        viewportHeight = $(element).parent().innerHeight();
    } else {
        viewportWidth = $(window).innerWidth();
        viewportHeight = $(window).innerHeight();
    }

    var $element = $(element);

    var elementWidth = $element.attr('width');
    var elementHeight = $element.attr('height');

    // Aspect ratio = height / width
    var viewportRatio = viewportHeight / viewportWidth;
    var videoRatio = elementHeight / elementWidth;

    //console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);


    var newWidth = (elementWidth / elementHeight) * viewportHeight
    var newHeight = (elementHeight / elementWidth) * viewportWidth;
    var newTop = 0;

    if (viewportRatio > videoRatio) {
        // set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
        //console.log('crop left and right');
        $element.css('height', viewportHeight);
        $element.css('width', newWidth);
        $element.css('left', '-' + (newWidth - viewportWidth) / 2 + 'px');
        $element.css('top', '0');
    } else if (viewportRatio < videoRatio) {
        // set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
        //console.log('crop top and bottom');
        $element.css('width', viewportWidth);
        $element.css('height', newHeight);
        $element.css('left', '0');
        $element.css('top', '-' + (newHeight - viewportHeight) / 2 + 'px');
    } else {
        // set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
        //console.log('no crop');
        $element.css('height', viewportHeight);
        $element.css('width', viewportWidth);
        $element.css('left', '0');
        $element.css('top', '0');
    }
}






function initSliders() {

	$('.home-slider__inner, .sub-slider__inner').reformSlider({
		speed: 4000,
		animationSpeed: 1000,
		arrows: false,
		pagination: true,
		paginationArrows: true
	});

	if ($('.home-slider__inner').length > 0) {
		// Dynamically set the right image and text for the first slide for current time of day
		$('[data-morning-image]').each( function () {
			$(this).css('background-image', 'url("' + $(this).data(timeOfDay() + '-image') + '")');
		});

		switch (timeOfDay()) {
			case 'morning':
				$('.home-slider__caption--morning').addClass('home-slider__caption--visible');
				break;
			case 'afternoon':
				$('.home-slider__caption--afternoon').addClass('home-slider__caption--visible');
				break;
			case 'evening':
				$('.home-slider__caption--evening').addClass('home-slider__caption--visible');
				break;
		}

		// Make sure the slider always fills the whole screen
		coverViewport($('.home-slider__inner'), true);
		$(window).on('resize', function () {
			coverViewport($('.home-slider__inner'), true);
		});
	}

	$('.home-slider__scroll button').on('click', function () {
		$('html, body').animate({
			scrollTop: $('.home-slider__inner').outerHeight() - $('.header').outerHeight()
		}, 500);
	});





	$('.home-offers__carousel').slick({
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 950,
				settings: {
					slidesToShow: 1,
					//centerMode: true,
					arrows: true,
					prevArrow: $('.home-offers__prev button'),
					nextArrow: $('.home-offers__next button'),
					dots: true,
					appendDots: $('.home-offers__dots')
				}
			}
		]
	});


	$('.other-rooms__carousel').slick({
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 950,
				settings: {
					slidesToShow: 1,
					//centerMode: true,
					arrows: true,
					prevArrow: $('.other-rooms__prev button'),
					nextArrow: $('.other-rooms__next button'),
					dots: true,
					appendDots: $('.other-rooms__dots')
				}
			}
		]
	});




	$('.generic-carousel__carousel').slick({
		arrows: true,
		fade: true
	});
}

function checkCarouselSlides() {
	if ( $('.generic-carousel__item').length <2 ) {
		$('.generic-carousel__number').css('display', 'none');
	}
}

function timeOfDay() {
	var today = new Date();
	var time = 'morning';
	if (today.getHours() >= 12) {
		time = 'afternoon';
	}
	if (today.getHours() >= 18) {
		time = 'evening';
	}
	return time;
}




function initAnimateInView() {
	$(window).on('DOMContentLoaded load resize scroll', animateElementsInView);
	animateElementsInView();
}

function animateElementsInView() {
	$('[data-animate-in-view]').each(function () {
		//console.log($(this));
		if ( isElementInViewport($(this)) ) {
			$(this).addClass( $(this).data('animate-in-view') );
		}
	});
}

// https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
function isElementInViewport (el) {
    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
	    rect.top <=  $(window).scrollTop() + window.innerHeight
    );
}




function initHeadings() {
	// Find '&' characters in headings and wrap them with a span to make them styleable
	var selectors = [
		".home-offers__heading h2:contains('&')"
	];

	$(selectors.join(',')).html(function(_, html) {
		return html.replace(/(&amp;)/g, '<span>$1</span>');
	});
}




function initForms() {
	$('.validate-this').validate();

	$('.custom-select select').selectric();

}




function initOffCanvas() {
	// Generate the dynamic sub nav
	$('#offCanvas').on('opened.zf.offcanvas', function () {
    		var count = 0;
    		$('.burger__primary > ul > li').each(function () {
    			if ( $(this).find('ul').length > 0 ) {
    				var $landingLink = $(this).find('a').first();

    				$('.burger__inner').append( '<nav id="burger__sub-' + count + '" class="burger__sub" style="padding-top: ' + (($(this).offset().top - window.pageYOffset)*0.8) + 'px"><button class="burger__sub-close" type="button">Close sub menu</button><ul><li><a href="' + $landingLink.attr('href') + '">' + $landingLink.text() + ' Overview</a></li>' + $(this).find('ul').html() + '</ul></nav>' );

    				$landingLink.data('open-sub', count);

    				count++;
    			}
    		});
	});

	// Open the dynamic sub nav only for items which have it
	$('.burger__primary > ul > li > a').on('click', function () {
		if ( typeof $(this).data('open-sub') !== 'undefined' ) {
			var subId = $(this).data('open-sub');

			$('.burger__sub--is-open').removeClass('burger__sub--is-open');

			$('#burger__sub-' + subId).addClass('burger__sub--is-open');

			return false;
		}
	});

	$(document).on('click', '.burger__sub-close', function () {
		$(this).parent().removeClass('burger__sub--is-open');
	});

	$('#offCanvas').on('closed.zf.offcanvas', function () {
		$('.burger__sub--is-open').removeClass('burger__sub--is-open');
		$('.burger__sub').remove();
	});
}



function initAccordions() {
	$('.accordion').accordiom({
		showFirstItem: false
	});

	$('.accordion .accordionContent').each( function () {
		$(this).after('<button class="accordion__rule" aria-hidden="true"></button>');
	});

	$('.accordion__rule').on('click', function () {
		$(this).prevAll('.accordionButton').first().trigger('click');
	});
}







var customMapStyle = [{"featureType":"all","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"saturation":"11"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"color":"#ffffff"},{"visibility":"on"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#4d4a43"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#4d4a43"},{"visibility":"on"}]},{"featureType":"administrative","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"lightness":"-30"}]},{"featureType":"administrative.neighborhood","elementType":"geometry","stylers":[{"saturation":"-43"},{"lightness":"-19"},{"gamma":"1.87"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text","stylers":[{"weight":"3.96"},{"gamma":"1.88"},{"lightness":"-12"},{"saturation":"-100"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#fafafa"},{"visibility":"simplified"}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#4d4a43"},{"lightness":"0"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#d6eae8"},{"lightness":"0"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45},{"visibility":"simplified"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"weight":"1.00"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#ffffff"},{"weight":"5.00"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"visibility":"on"},{"weight":"3"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ebebeb"},{"visibility":"on"},{"weight":"1"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#4d4a43"},{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#aaaaaa"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry","stylers":[{"saturation":"9"},{"color":"#001e3d"}]}];

function initMaps() {
	$('[data-map]').each(function () {
		var map, centerLat, centerLng, zoom, marker, markerLat, markerLng;

		if (typeof $(this).data('map-center-coords') != 'undefined') {
			centerLat = parseFloat( $(this).data('map-center-coords').split(',')[0] );
			centerLng = parseFloat( $(this).data('map-center-coords').split(',')[1] );
		} else {
			centerLat = 0;
			centerLng = 0;
		}

		zoom = $(this).data('map-zoom') || 8;

		if (typeof customMapStyle !== 'undefined') {
			map = new google.maps.Map($(this)[0], {
				center: {lat: centerLat, lng: centerLng},
				zoom: zoom,
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				styles: customMapStyle
			});
		} else {
			map = new google.maps.Map($(this)[0], {
				center: {lat: centerLat, lng: centerLng},
				zoom: zoom,
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false
			});
		}


		if (typeof $(this).data('map-marker-coords') != 'undefined') {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}

			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});

			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		}

		$(this).siblings('[data-map-marker]').each(function () {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}

			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});

			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		});

		if (typeof $(this).data('map-directions') != 'undefined') {
			var directionsService  = new google.maps.DirectionsService();
			var directionsRenderer = new google.maps.DirectionsRenderer();
			directionsRenderer.setMap(map);
			directionsRenderer.setPanel($('#map-directions-data').get(0));

			var directionsTo = $(this).data('map-directions-destination');

			$('#frmPostcode').on('submit', function() {
				var directionsFrom = jQuery.trim(jQuery('#tbPostcode').val());
				var directionsRequest = {
					origin: directionsFrom,
					destination: directionsTo,
					travelMode: google.maps.TravelMode.DRIVING,
					unitSystem: google.maps.UnitSystem.IMPERIAL
				};

				directionsService.route(directionsRequest, function(result, status){
			    	if (status == google.maps.DirectionsStatus.OK) {
						marker.setMap(null);
						directionsRenderer.setDirections(result);
			    	} else {
				    	alert('Location "' + directionsFrom + '" not found.');
			    	}
				});

				return false;
			});
		}
	});
}




function initBlog() {
	function getBlogPosts(url) {
		$.ajax({ type: 'GET',
			url: url,
			success : function(blogPosts) {
				$('.blog-landing').append(blogPosts);
			}
		});
	}

	// Blog pages
	$(document.body).on('click', '.blog-landing__load', function () {
		$loadButton = $(this);

		$loadButton.animate({
			'opacity': 0,
			'marginTop': 0,
			'marginBottom': 0,
			'height': 0
		});

		setTimeout(function () {
			$loadButton.parent().remove();
		}, 500);

		getBlogPosts($loadButton.data('blog-posts'));
	});
}




function initGallery() {
	$('.gallery__thumb').on('click', function () {
		// Dynamically load the gallery slider into a reveal popup
		var $modal = $('<div id="gallery-modal" class="gallery-modal full reveal loading" data-reveal><button class="gallery-modal__close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><div class="gallery-modal__title">' + $(this).text() + '</div><div class="gallery-modal__slider"></div></div>');

        $('body').append($modal);

        $modal.find('.gallery-modal__slider').load($(this).attr('href'), function () {
	        $modal.removeClass('loading').find('.gallery-modal__slider').slick({
		        arrows: true,
		        fade: true
	        });
        });

        $('#gallery-modal').foundation();
        $modal.foundation('open');

        $modal.on('closed.zf.reveal', function () {
	        $modal.remove();
        });

        return false;
	});
}





function initBooking() {

	$('#bookingOffCanvas').on('opened.zf.offcanvas', function () {
		// lazy load the iframe sources
		$('.booking iframe').each(function () {
			$iframe = $(this);
			
			if (typeof $iframe.data('src') != 'undefined') {
				$iframe.attr('src', $iframe.data('src'));
				
				setTimeout(function () {
					$iframe.addClass('loaded');
				}, 750);
			}
		});

		// display the right widget for the current section
		$('.booking__nav a.current').trigger('click');
	});


	$('.booking__nav a').on('click', function () {
		if ($(this).attr('href').indexOf('http') > -1) {
			return; // pass through for the vouchers link
		}

		$('.booking__nav a').removeClass('current');
		$(this).addClass('current');

		$('.booking__option').hide();
		$('.booking__' + $(this).attr('href').replace('#', '')).show();


		// refresh the table booking widget
		$('.booking__table iframe').each(function () {
			$(this).attr('src', $(this).attr('src'));
		});

		return false;
	});



	$('a[href="#book-table"]').on('click', function () {
		$('.header__book-cta, .booking__nav a[href="#table"]').trigger('click');
		return false;
	});



	var nowTemp = new Date();
	var tomorrow = new Date();
		tomorrow.setDate(nowTemp.getDate() + 1);
	var now = new Date(nowTemp.getFullYear(), nowTemp.getMonth(), nowTemp.getDate(), 0, 0, 0, 0);
	var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

	var checkin = $('#check-in').fdatepicker({
		format: 'd',
		initialDate: nowTemp,
		onRender: function (date) {
			return date.valueOf() < now.valueOf() ? 'disabled' : '';
		}
	}).on('changeDate', function (ev) {
		if (ev.date.valueOf() > checkout.date.valueOf()) {
			var newDate = new Date(ev.date)
			newDate.setDate(newDate.getDate() + 1);
			checkout.update(newDate);
		}
		updateDates();
		checkin.hide();
		$('#check-out')[0].focus();
	}).data('datepicker');
	var checkout = $('#check-out').fdatepicker({
		format: 'd',
		initialDate: tomorrow,
		onRender: function (date) {
			return date.valueOf() <= checkin.date.valueOf() ? 'disabled' : '';
		}
	}).on('changeDate', function (ev) {
		updateDates();
		checkout.hide();
	}).data('datepicker');

	updateDates();

	function updateDates() {
		if ($('input[name="arrival"]').length > 0) {
			//$('input[name="arrival"]').val( pad((checkin.date.getDate()), 2) + '/' + pad((checkin.date.getMonth()*1 + 1*1), 2) + '/' + checkin.date.getFullYear());
			//$('input[name="departure"]').val( pad((checkout.date.getDate()), 2) + '/' + pad((checkout.date.getMonth()*1 + 1*1), 2) + '/' + checkout.date.getFullYear());

			$('input[name="arrival"]').val( checkin.date.getFullYear() + '-' + pad((checkin.date.getMonth()*1 + 1*1), 2) + '-' + pad((checkin.date.getDate()), 2) );
			$('input[name="departure"]').val( checkout.date.getFullYear() + '-' + pad((checkout.date.getMonth()*1 + 1*1), 2) + '-' + pad((checkout.date.getDate()), 2) );

			$('#check-in-month').text( months[checkin.date.getMonth()] + ', ' + checkin.date.getFullYear() );
			$('#check-out-month').text( months[checkout.date.getMonth()] + ', ' + checkout.date.getFullYear() );

			$('input[name="numberOfNights"]').val( numberOfNightsBetween(checkin.date, checkout.date) );
		}
	}



	function numberOfNightsBetween(first, second) {
	    return (second-first)/(1000*60*60*24);
	}



    // picker changers
    $('.booking__picker-up').on('click', function () {
        var input = $(this).next('input');
        var val = parseInt(input.val());

        if (isNaN(val)) {
            return;
        }

        val += 1;

        // test new value against field pattern
        var pattern = input.attr('pattern');
        var regex = new RegExp('^' + pattern + '$');

        if (regex.test(val)) {
            // matches pattern, so change it
            input.val(val);
        }
    });

    $('.booking__picker-down').on('click', function () {
        var input = $(this).prev('input');
        var val = parseInt(input.val());

        if (isNaN(val)) {
            return;
        }

        val -= 1;

        // test new value against field pattern
        var pattern = input.attr('pattern');
        var regex = new RegExp('^' + pattern + '$');

        if (regex.test(val)) {
            // matches pattern, so change it
            input.val(val);
        }
    });

}

function initPopup() {

    if ( $('#popup').length > 0 ) {
        var popupDelay = $('#popup').data('popup-delay') || 0;
        var popupKeepHiddenFor = $('#popup').data('popup-keep-hidden-for-n-days') || 0;

        if (!Cookies.get('hasSeenPopup')) {
            setTimeout(function () {
                $('#popup').foundation('open');

                if (popupKeepHiddenFor > 0) {
                	Cookies.set('hasSeenPopup', 'true', {expires: popupKeepHiddenFor});
                }
            }, popupDelay)
        }
    }
}
